import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {getViewImage} from '~/utils/catalog';
// components
import ProductImage from './ProductImage';
export {default as ProductImage} from './ProductImage';

import './index.scss';

const propTypes = {
  anchorPoint: PropTypes.shape({
    left: PropTypes.number,
    top: PropTypes.number
  }).isRequired,
  styleId: PropTypes.string.isRequired,
  children: PropTypes.element,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isSleeveDecoEligible: PropTypes.bool,
  main: PropTypes.bool,
  product: PropTypes.object,
  selectedColorDefinition: PropTypes.shape({
    id: PropTypes.string,
    view_images: PropTypes.arrayOf(
      PropTypes.shape({
        alt_uri: PropTypes.string,
        name: PropTypes.string,
        uri: PropTypes.string
      })
    )
  }),
  selectedViewName: PropTypes.string,
  showOverlay: PropTypes.bool,
  similarProductWithImages: PropTypes.object,
  // handlers
  onProductRender: PropTypes.func
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
export default class Product extends Component {
  static displayName = 'Product';
  static propTypes = propTypes;

  static defaultProps = {
    onProductRender() {},
    height: '100%'
  };

  state = {
    imageLoaded: false
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const nextProductImage =
      nextProps.selectedViewName + nextProps.selectedColorDefinition.id;
    const currProductImage =
      this.props.selectedViewName + this.props.selectedColorDefinition.id;
    if (currProductImage !== nextProductImage) {
      this.setState({imageLoaded: false});
    }
  }

  handleImageLoad = event => {
    const {naturalHeight, naturalWidth} = event.target;
    this.setState({imageLoaded: true});
    this.props.onProductRender({height: naturalHeight, width: naturalWidth});
  };

  renderProductImage() {
    const {
      anchorPoint,
      height,
      isSleeveDecoEligible,
      product,
      selectedColorDefinition,
      selectedViewName,
      similarProductWithImages,
      styleId,
      main
    } = this.props;
    const style = {
      ...anchorPoint,
      height
    };
    const categoryIds = product ? product.category_ids : null;

    const viewImage = getViewImage(selectedColorDefinition, selectedViewName);

    if (viewImage !== undefined) {
      const {alt_large_uri, alt_uri, uri} = viewImage;
      const altPath = main ? alt_large_uri : alt_uri;

      return (
        <div style={{width: '100%', height: '100%'}}>
          <ProductImage
            altImagePath={altPath}
            categoryIds={categoryIds}
            className="ndx-Product-photo"
            height={height}
            imagePath={uri}
            isSleeveDecoEligible={isSleeveDecoEligible}
            product={this.props.product}
            productId={selectedColorDefinition.id}
            showLoader={main}
            showOverlay={this.props.showOverlay}
            style={style}
            styleId={styleId}
            similarProduct={similarProductWithImages}
            viewName={selectedViewName}
            onLoad={this.handleImageLoad}
          />
        </div>
      );
    }
  }

  render() {
    const childElement = React.Children.only(this.props.children);
    return (
      <div className="ndx-Product">
        {this.renderProductImage()}
        {React.cloneElement(childElement, {
          productRendered: this.state.imageLoaded
        })}
      </div>
    );
  }
}
